// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"aa3ff575","404":"951ffd61","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};